export enum EPreSignedUploadFileType {
  SOCIAL_POST_MEDIA = 'SOCIAL_POST_MEDIA',
  USER_PROFILE_IMAGE = 'USER_PROFILE_IMAGE',
  CANDIDATE_PROFILE_IMAGE = 'CANDIDATE_PROFILE_IMAGE',
  HOME_BANNER = 'HOME_BANNER',
  DATA_IMPORT = 'DATA_IMPORT',
  LOGO_APP = 'LOGO_APP',
  LOGO_WEB = 'LOGO_WEB',
  GENERIC_DOCUMENT = 'GENERIC_DOCUMENT',
  CANDIDATE_CV = 'CANDIDATE_CV',
  OMBUDSMAN_EXTERNAL = 'OMBUDSMAN_EXTERNAL',
}
